// Scripts librairies
import { docReady } from './js/libs/utils'

// Charge la base commune
require('./common.js')

docReady(function () {
  // gestion des filtres depuis la navbar
  const $mn = document.getElementById('sub-nav')
  const $h = document.getElementById('header')
  const openHeader = function () {
    const stickyEl = $mn.closest('.sticky-top')
    if ($h.querySelector('.navbar-collapse').classList.contains('show')) {
      stickyEl.style.zIndex = '999'
    } else {
      stickyEl.style.zIndex = '1020'
    }
  }
  $h.querySelector('.navbar-toggler[data-trigger]').addEventListener('click', openHeader)
  $h.querySelector('.navbar-close').addEventListener('click', openHeader)
  if ($mn && $mn.querySelector('.navbar-toggler[data-trigger]')) {
    const openSubnav = function () {
      const stickyEl = $mn.closest('.sticky-top')
      if ($mn.querySelector('.navbar-collapse').classList.contains('show')) {
        stickyEl.style.zIndex = '1020'
      } else {
        stickyEl.style.zIndex = '999'
      }
    }
    $mn.querySelector('.navbar-toggler[data-trigger]').addEventListener('click', openSubnav)
    $mn.querySelector('.navbar-close').addEventListener('click', openSubnav)
  }

  // boutons d'action sur le modèle détaillé
  const financingBtn = document.getElementById('track-f')
  if (financingBtn) {
    financingBtn.addEventListener('click', () => {
      /* global gtag */
      if (typeof (googletag) !== 'undefined') { gtag('event', 'financing_offer') }
    })
  }
  const contactBtn = document.getElementById('track-c')
  const contactBtn2 = document.getElementById('track-c2')
  if (contactBtn) {
    contactBtn.addEventListener('click', () => {
      if (typeof (googletag) !== 'undefined') { gtag('event', 'contact_offer') }
    })
  }
  if (contactBtn2) {
    contactBtn2.addEventListener('click', () => {
      if (typeof (googletag) !== 'undefined') { gtag('event', 'contact_offer') }
    })
  }

  // auto-anchor
  const target = document.getElementById('detail-offre')
  if (target) {
    setTimeout(() => {
      target.scrollIntoView({ behavior: 'smooth' })
    }, 800)
  }
})
